import showConfirmAlert from './showConfirmAlert'
import showAlert from './showAlert'
import { LOGIN_URL } from '../constants'

export const errorProcess = (res = {}) => {
    showAlert('error', `${res.d} 错误码: ${res.c}`)
}

//TODO  设计更好的中间件的方式承载
export const cgiCallWrapper = async (apiMethod, params, isShowAlert = true) => {
    let _showAlert = isShowAlert ? showAlert : () => {}
    let _showConfirmAlert = isShowAlert ? showConfirmAlert : () => {}
    try {
        const res = await apiMethod(params)
        if (res.c === 403) {
            await _showConfirmAlert('error', res.d)
            window.location.href = LOGIN_URL
        } else if (res.c === 200) {
            return res
        } else {
            isShowAlert && errorProcess(res)
            return res
        }
    } catch (e) {
        _showAlert('error', e.message)
        return e
    }
}
